export default {
    methods: {
        cityStateZip(address) {
            let str = '';

            if (address.city && address.city.length) {
                str += address.city;
            }

            if (address.city && address.city.length && address.state && address.state.length) {
                str += `, ${address.state}`;
            }

            if (address.zip && address.zip.length) {
                str += ` ${address.zip}`;
            }

            return str;
        },
        country(code) {
            for (let i = 0; i < this.countries.length; i++) {
                if (this.countries[i].code === code) {
                    return this.countries[i].name;
                }
            }
        },
    }
}